export const PUBLISHING_PLATFORM_TYPE = {
  PUBLICATION: "publication",
  SOCIAL_NETWORK: "social_network",
  SYNDICATION_MARKETPLACE: "syndication_marketplace",
  EMAIL: "email",
};

// Modal States
export const STORY_MODAL_STATE_PUBLISH_NOW = "publish_now";
export const STORY_MODAL_STATE_PUBLISH_LATER = "publish_later";

// Modal Labels
export const STORY_MODAL_LABEL_PUBLISH_NOW = "Publish Now";
export const STORY_MODAL_LABEL_PUBLISH_LATER = "Publish Later";

// Modal Tooltips
export const STORY_MODAL_TOOLTIP_PUBLISH_NOW = "Publish Now";
export const STORY_MODAL_TOOLTIP_PUBLISH_LATER = "Publish Later";

// Modal Descriptions
export const STORY_MODAL_DESCRIPTION_PUBLISH_NOW = "Publish your changes now. Your story will go live and will be visible to users immediately.";
export const STORY_MODAL_DESCRIPTION_SUBMIT_FOR_REVIEW = "Submit your changes for review. Once approved, they will be published automatically and will be visible to users.";
export const STORY_MODAL_DESCRIPTION_SCHEDULE = "Schedule your changes to be published at a specific date and time. They will go live automatically and be visible to users once published.";
export const STORY_MODAL_DESCRIPTION_SCHEDULE_NEEDS_REVIEW = "Choose a date and time for your changes to be published. Your changes will be reviewed first and, once approved, will be published automatically at the scheduled time.";

// Modal Button Labels
export const STORY_MODAL_PRIMARY_BUTTON_LABEL_PUBLISH_NOW = "Publish Now";
export const STORY_MODAL_PRIMARY_BUTTON_LABEL_PUBLISH_LATER = "Publish Later";
export const STORY_MODAL_PRIMARY_BUTTON_LABEL_SUBMIT_FOR_REVIEW = "Submit For Review";
export const STORY_MODAL_PRIMARY_BUTTON_LABEL_REQUEST_SCHEDULING = "Request Scheduling";
